import { Popup, useMap, useMapEvents } from "react-leaflet";
import Loading from './../common/loading';
import { useEffect, useRef, useState } from "react";
import useApi from './../../utilities/useApi';
import { Button, Form, Modal, Table, Dropdown } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import stringUtilities from "../../utilities/stringUtilities";
import enums from "../../utilities/enums";
import arrayUtilities from "../../utilities/arrayUtilities";
import roleUtilities from "../../utilities/roleUtilities";
import moment from "moment";

var hash = require('object-hash');

export default function DataPopup(props) {

    const { api } = useApi();
    const map = useMap();
    const ref = useRef();
    const [isLoading, setIsLoading] = useState(props.point ? true : false);
    const [point, setPoint] = useState(props.point);
    const [canEditFeature, setCanEditFeature] = useState(false);
    const [deleteModalIsVisible, setDeleteModalIsVisible] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [showUndeleteModal, setShowUndeleteModal] = useState(false);

    const [deleteMode, setDeleteMode] = useState(props.canDeletePoint ? 0 : 1)
    const [undeleteMode, setUndeleteMode] = useState(props.canDeletePoint ? 0 : 1)

    const onEdit = function () {

        map.closePopup();
        if (props.onEdit) {
            props.onEdit();
        }
    };

    const onEditFeature = () => {
        map.closePopup();
        if (props.onEditFeature) {
            props.onEditFeature(point);
        }
    }

    const onMoveData = () => {
        map.closePopup();
        if (props.onMoveData) {
            props.onMoveData(point);
        }
    }

    const onUndeleteData = () => {
        map.closePopup();
        if (props.onUndeleteData) {
            props.onUndeleteData();
        }
    }

    const onUndeleteGeometry = () => {
        map.closePopup();
        if (props.onUndeleteGeometry) {
            props.onUndeleteGeometry(undeleteMode);
        }
    }

    const onDeleteConfirm = function () {

        setDeleteModalIsVisible(false);
        setIsLoading(true);
        map.closePopup();
        if (props.onDeleteData) {
            props.onDeleteData(deleteMode);
        }
    };

    useEffect(() => {
        if (point !== null && props.user && point.user) {
            setCanEditFeature(props.sketch === null && ((props.user.id === point.user.id && moment().diff(point.timestamp, 'days') <= 10 && roleUtilities.isCollectorOrEditor(props.user)) || roleUtilities.hasOrgAdminCapability(props.user)));
        }
    }, [point]);

    useMapEvents({
        popupopen: (e) => {
            if ((point === null || point === undefined) && ref.current._leaflet_id === e.popup._leaflet_id) {
                api.getPoint(props.organisationId, props.projectId, props.pointId, (data) => {
                    setPoint(data);
                    setIsLoading(false);
                }, () => { });
            }
        }
    });

    return <>
        <Popup className="data-popup" ref={ref}>
            <div className='card border-0'>
                <div className='card-footer d-flex flex-column justify-content-center mx-2 px-0 text-nowrap'>
                    {(!point || point === null)
                        ? <Loading />
                        : <>
                            <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: '15rem' }}>
                                <Table size="sm" striped>
                                    <tbody>
                                        {point.formData && point.formData !== null && <>
                                            <tr>
                                                <td colSpan={2}><h3 className="h6 px-0 m-0">Form Data</h3></td>
                                            </tr>
                                            {Object.keys(point.formData).map((key, index) => <tr index={index} key={`point-popup-formdata-${index}`}>
                                                <td><strong className="p-0">{stringUtilities.camelCaseToWords(key)}</strong></td>
                                                <td>{point.formData[key]}</td>
                                            </tr>)}
                                        </>}
                                        <tr>
                                            <td colSpan={2}><h3 className="h6 px-0 m-0">Project Data</h3></td>
                                        </tr>
                                        <tr>
                                            <td><strong className="p-0">Workflow</strong></td>
                                            <td>{point.workflow}</td>
                                        </tr>
                                        <tr>
                                            <td><strong className="p-0">Job</strong></td>
                                            <td>{point.job}</td>
                                        </tr>
                                        <tr>
                                            <td><strong className="p-0">Type</strong></td>
                                            <td>{point.formData?.Type}</td>
                                        </tr>
                                        <tr>
                                            <td><strong className="p-0">User</strong></td>
                                            <td>{point.user?.name}</td>
                                        </tr>
                                        {point.sensorData && point.sensorData !== null && <>
                                            <tr>
                                                <td colSpan={2}><h3 className="h6 px-0 m-0">Sensor Data</h3></td>
                                            </tr>
                                            {Object.keys(point.sensorData).map((key, index) => <tr index={index} key={`point-popup-sensordata-${index}`}>
                                                <td><strong className="p-0">{stringUtilities.camelCaseToWords(key)}</strong></td>
                                                <td>{point.sensorData[key]}</td>
                                            </tr>)}
                                        </>}

                                        {point.gpsData && point.gpsData !== null && <>
                                            <tr>
                                                <td colSpan={2}><h3 className="h6 px-0 m-0">GPS Data</h3></td>
                                            </tr>
                                            {Object.keys(point.gpsData).map((key, index) => <tr index={index} key={`point-popup-gpsdata-${index}`}>
                                                <td><strong className="p-0">{stringUtilities.camelCaseToWords(key)}</strong></td>
                                                <td>{stringUtilities.formatDate(point.gpsData[key])}</td>
                                            </tr>)}
                                        </>}

                                        {!arrayUtilities.isNullOrEmpty(point.photos) && <>
                                            <tr>
                                                <td colSpan={2}><h3 className="h6 px-0 m-0">Photos</h3></td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <div className="data-popup-photos">
                                                        {point.photos.map((photo, index) => <div className="data-popup-photo" index={index} key={hash(photo)}>
                                                            <a href={photo} target="_blank"><img src={photo} /></a>
                                                        </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </>}
                                    </tbody>
                                </Table>
                            </SimpleBar>
                            {
                                !props.isPreview && 
                                <>
                                    {
                                        !point.isDeleted ?
                                        <div className="dropdown-trigger d-flex w-100 justify-content-end mt-2 mr-1">
                                            {
                                                props.connectionOriginalPoint
                                                    ? <Button onClick={ () => {
                                                        map.closePopup()
                                                        if (props.onClickConnect) {
                                                            props.onClickConnect(point)
                                                        }
                                                    } }
                                                        variant="secondary" size="sm"><i className='fi-link me-2'></i>Connect to this Point
                                                    </Button>
                                                    : <Dropdown drop='up'>
                                                        <Dropdown.Toggle size="sm" variant="secondary">Actions</Dropdown.Toggle>
                                                        <Dropdown.Menu align='end' className='my-1'>
                                                            { props.canEdit && <Dropdown.Item className="d-flex align-items-center" onClick={ onEdit }><i className='fi-edit me-2'></i> Edit</Dropdown.Item> }

                                                            {
                                                                canEditFeature &&
                                                                <>
                                                                    <Dropdown.Item className="d-flex align-items-center" eventKey='2' onClick={ onEditFeature }><i className='fi-edit me-2'></i> Edit</Dropdown.Item>
                                                                    <Dropdown.Item className="d-flex align-items-center" eventKey='3' onClick={ () => setShowWarningModal(true) }><i className='fi-external-link me-2'></i>Move</Dropdown.Item>
                                                                </>
                                                            }
                                                            {
                                                                roleUtilities.isCollectorOrEditor(props.user) && props.showConnectOption 
                                                                && <Dropdown.Item onClick={ () => {
                                                                    map.closePopup()
                                                                    if (props.onClickConnect) {
                                                                        props.onClickConnect(point)
                                                                    }
                                                                } }><i className='fi-link me-2'></i>Connect Point</Dropdown.Item>
                                                            }
                                                            
                                                            <Dropdown.Divider />
                                                            {
                                                                ((roleUtilities.hasOrgAdminCapability(props.user) || roleUtilities.isCollectorOrEditor(props.user)) || props.user.id === point?.user?.id) &&
                                                                <Dropdown.Item className="d-flex align-items-center" onClick={ () => setDeleteModalIsVisible(true) }><i className='fi-trash me-2 text-danger'></i> <span className="text-danger">Delete</span></Dropdown.Item>
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                            }
                                        </div>
                                        : (props.onUndeleteData || props.onUndeleteGeometry) && <div className="d-flex w-100 justify-content-end mt-2 mr-1">
                                            <Button className="d-flex align-items-center" onClick={ () => setShowUndeleteModal(true) } size="sm" variant="secondary">
                                                <i className='fi-rotate-left me-2 mt-1 mb-1 text-primary'></i> <span className="text-primary">Un-delete</span>
                                            </Button>
                                        </div>
                                    }
                                </>
                            }
                        </>}
                </div>
            </div>
        </Popup>
        <Modal show={deleteModalIsVisible} onHide={() => setDeleteModalIsVisible(false)} centered>
            <Modal.Header>
                <Modal.Title>{`Delete ${props.canDeletePoint ? "Point" : ""}${props.canDeletePoint && props.canDeleteGeometry ? "/" : ""}${props.canDeleteGeometry ? (props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]) : ""}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3"></p>
                {props.canDeletePoint &&
                    <Form.Check type='radio' id='delete-radio-point' name='delete-radio' label='Delete this Point only' value={0} checked={deleteMode === 0} onChange={(e) => setDeleteMode(Number(e.target.value))} />
                }
                {props.canDeleteGeometry &&
                    <>
                        <Form.Check type='radio' id='delete-radio-geometry' name='delete-radio' label={`Delete this ${props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]} only`} value={1} checked={deleteMode === 1} onChange={(e) => setDeleteMode(Number(e.target.value))} />
                        <Form.Check type='radio' id='delete-radio-geometry-and-point' name='delete-radio' label={`Delete this ${props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]} and associated Points`} value={2} checked={deleteMode === 2} onChange={(e) => setDeleteMode(Number(e.target.value))} />
                    </>
                }
                {props.canDeletePoint && props.canDeleteGeometry &&
                    <Form.Check type='radio' id='delete-radio-split-geometry' name='delete-radio' label={`Delete this Point and split the ${props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]}`} value={3} checked={deleteMode === 3} onChange={(e) => setDeleteMode(Number(e.target.value))} />
                }
                {
                props.canDeleteGeometry &&
                    <Form.Check type='radio' id='split-geometry-no-delete' name='delete-radio' label={`Split this ${props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]} and keep the Point`} value={4} checked={deleteMode === 4} onChange={(e) => setDeleteMode(Number(e.target.value))} />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='secondary' onClick={() => setDeleteModalIsVisible(false)}>Cancel</Button>
                <Button size="sm" variant="danger" onClick={onDeleteConfirm}>Delete</Button>
            </Modal.Footer>
        </Modal>

        <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)} centered>
            <Modal.Header>
                <Modal.Title className="d-flex gap-2 align-items-center"><i className='fi-alert-triange text-warning' />Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="m-0">Are you sure you want to move this data point?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='secondary' onClick={() => setShowWarningModal(false)}>Cancel</Button>
                <Button size="sm" variant="primary" onClick={() => {
                    setShowWarningModal(false)
                    onMoveData()
                }}>Confirm</Button>
            </Modal.Footer>
        </Modal>
        <Modal show={showUndeleteModal} onHide={() => setShowUndeleteModal(false)} centered>
            <Modal.Header>
                <Modal.Title className="d-flex gap-2 align-items-center"><i className='fi-alert-triange text-warning' />Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    (props.canDeletePoint && props.canDeleteGeometry)
                    ? <>
                        <Form.Check type='radio' id='undelete-radio-point' name='undelete-radio' label="Undelete this Point" value={0} checked={undeleteMode === 0} onChange={(e) => setUndeleteMode(Number(e.target.value))} />
                        <Form.Check type='radio' id='undelete-radio-line' name='undelete-radio' label={`Undelete this ${props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]}`} value={1} checked={undeleteMode === 1} onChange={(e) => setUndeleteMode(Number(e.target.value))} />
                    </>
                    : props.canDeletePoint
                        ? <p>Are you sure you want to undelete this Point?</p>
                        : props.canDeleteGeometry && <p>Are you sure you want to undelete this {props.geometryType === 0 ? "Line" : enums.GeometryType[props.geometryType]}?</p>
                }    
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='secondary' onClick={() => setShowUndeleteModal(false)}>Cancel</Button>
                <Button size="sm" variant="primary" onClick={() => {
                    setShowUndeleteModal(false)
                    if (undeleteMode === 0) {
                        onUndeleteData()
                    }
                    if (undeleteMode === 1) {
                        onUndeleteGeometry()
                    }
                }}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    </>
}